var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding_page"},[_vm._m(0),_c('div',{staticClass:"wizard_actions"},[_c('button',{staticClass:"btn_next",on:{"click":_vm.next_page}},[_vm._v(" Nästa ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[_c('h2',[_vm._v("😊 Välkommen till Memlist Onboarding")]),_c('p',[_vm._v("Denna wizard kommer att hjälpa dig att komma igång med Memlist.")])])
}]

export { render, staticRenderFns }